import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field, SelectField } from "@/components/crm/fields";

const TYPES = [["call", "Call log"], ["meeting", "Meeting notes"], ["note", "Note"], ["whatsapp", "WhatsApp"], ["visit", "Site visit"]];

export default function ActivityDialog({ open, onOpenChange, lead, type = "note", onSaved }) {
  const [f, setF] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setF({ type, content: "", outcome: "", next_action: "" }); }, [open, type]);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e?.target ? e.target.value : e }));
  const save = async () => {
    if (!f.content.trim()) { toast.error("Please add a short description"); return; }
    setSaving(true);
    try {
      await api.post(`/leads/${lead.lead_id}/activities`, { ...f, outcome: f.outcome || null, next_action: f.next_action || null });
      toast.success("Activity logged — stage timer refreshed");
      onOpenChange(false);
      onSaved?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="activity-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Log activity</DialogTitle>
          <DialogDescription>{lead?.company}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Field label="Type"><SelectField testid="activity-type-select" value={f.type} onChange={set("type")} options={TYPES} allowNone={false} /></Field>
          <Field label="What happened?"><Textarea data-testid="activity-content-input" rows={4} value={f.content || ""} onChange={set("content")} placeholder="Discussed bag specs, customer wants samples…" /></Field>
          {(f.type === "call" || f.type === "meeting") && (
            <Field label="Outcome"><SelectField testid="activity-outcome-select" value={f.outcome} onChange={set("outcome")}
              options={["Connected", "No answer", "Call back later", "Interested", "Not interested", "Requirement received"]} /></Field>
          )}
          <Field label="Next action" hint="(optional)"><Input data-testid="activity-next-action-input" value={f.next_action || ""} onChange={set("next_action")} className="h-9" placeholder="e.g. Send quotation by Friday" /></Field>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button className="bg-[#0B3C2D] hover:bg-[#072B20]" disabled={saving} onClick={save} data-testid="activity-save-button">{saving ? "Saving…" : "Save"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
